module.exports = __webpack_public_path__ + "img/2018-2.f1d0a68b.jpeg";